export default class Playbook {
  constructor ({ name, mechanisms, fields, rules, originalRulebook }) {
    Object.assign(this, { name, mechanisms, fields, rules, originalRulebook })
    this.rulebooks = this.originalRulebook.rulebooks
    this.valuables = []
      .concat(this.rules.formulas)
      .concat(this.rules.characterFields)
      .concat(this.rules.playbookFields)
      .concat(this.rules.globalFields)
      .concat(this.rules.choices)
      .concat(this.rules.procedures)
  }
}
